import styled from '@emotion/styled'

import SectionBase, * as Section from '@segment/matcha/recipes/Section'
import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'

import Cards from './components/Cards'

const copy = {
  heading: `Resources`,
  description: `Power your customer data strategy.`,
}

const Resources = () => {
  return (
    <Wrapper>
      <StyledSectionBase variant="centered">
        <Section.Copy>
          <CopyTextBase centered={true}>
            <CopyText.Heading variant="h2" tag="h2">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description tag="p" variant="pLarge">
              {copy.description}
            </CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <Cards />
        </Section.Contents>
      </StyledSectionBase>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  background: ${({ theme }) => theme.palette.twilio.gray[10]};
`
const StyledSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    gap: 64px;
    padding-top: 40px;
  }
`

export default Resources
